<template>
  <v-navigation-drawer v-model="drawer" app dark temporary>
  <span v-if="language==='RU'">
    <v-list>
      <v-list-tile 
        v-for="(link, i) in links_RU" :key="i"
          router
            :to="link.route"
              :href="link.href">
        <v-list-tile-title v-text="link.text" />
      </v-list-tile>
    </v-list>
  </span>

  <span v-if="language==='EN'">
    <v-list>
      <v-list-tile 
        v-for="(link, i) in links_EN" :key="i"
          router
            :to="link.route"
              :href="link.href">
        <v-list-tile-title v-text="link.text" />
      </v-list-tile>
    </v-list>
  </span>

  </v-navigation-drawer>
</template>

<script>
export default {
  name: 'Drawer',
  props:['drawer'],
    data () {
    return {
      language: '',
      links_RU: [
        {text: 'Биография', route: '/about'},
        {text: 'Аудио', route: '/audio'},  
        {text: 'Фото', route: '/gallery'}, 
        {text: 'Видео', route: '/video'},
        {text: 'Награды', route: '/awards'},        
        {text: 'Контакты', route: '/contacts'}                                                 
      ],
      links_EN: [
        {text: 'Biography', route: '/about'},
        {text: 'Audio', route: '/audio'},  
        {text: 'Photo', route: '/gallery'}, 
        {text: 'Videos', route: '/video'},
        {text: 'Awards', route: '/awards'},        
        {text: 'Contacts', route: '/contacts'}                                                 
      ]
    }
  },
  mounted() {
    if(localStorage.lang) {
        this.language = localStorage.lang
    }
  }
}
</script>